module.exports = __webpack_public_path__ + "static/media/vvexe32_1.b8c5f77d.ico";